import{useContext as o}from"react";import{AlgoliaSearchServiceContext as r}from"./algolia-search-service-context.js";const t=()=>o(r);export{t as useAlgoliaSearchServiceContext};
